import { Component, Vue, Watch } from 'vue-property-decorator';
import { api } from '@/galaxy-cruise/api';

@Component
export default class extends Vue {
  dontShowAgain = false

  get personalSetting() {
    const show_startup_hint = !this.dontShowAgain
    return { show_startup_hint }
  }

  @Watch('personalSetting')
  async onPersonalSettingChange() {
    const personal_setting_attributes = this.personalSetting
    const axios = api.default
    await axios.put('../api/v1/user', { user: { personal_setting_attributes } })
  }
}
